<template>
  <div class="flex h-screen">
    <!-- Sidebar affichée sauf sur /login -->
<NavbarView 
  v-if="!route.path.startsWith('/login')" 
  class="w-64 bg-gray-800 text-white sidebar" 
/>
    <!-- Contenu principal -->
    <main class="flex-1 overflow-auto">
        <MobileNavbar  v-if="!route.path.startsWith('/login')"  class="mobile-navbar " />
      <router-view class="pb-12" />
     
    </main>
  </div>
</template>

<script setup>
import { useRoute } from "vue-router";
import NavbarView from './components/NavbarView.vue';
import MobileNavbar from "./components/MobileNavbar.vue";
const route = useRoute();
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

.bebas-neue-regular {
  font-family: "Bebas Neue", sans-serif;
}
body {
  background-color: #ffffff;
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  color: rgb(0, 0, 0);
}
p {
  font-weight: normal !important;
  font-family: "Poppins", sans-serif;
}

/* Media query pour écran < 768px (mobile) */
@media (max-width: 767px) {
  .sidebar {
    display: none !important;
  }
  .mobile-navbar {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
}

@media (width > 767px) {
  .mobile-navbar {
    display: none;
  }
   .sm\:flex-row {
    display: flex !important;
    flex-direction: row !important; /* aligne en ligne */
  }
  .md\:flex-row {
    display: flex !important;
    flex-direction: row !important; /* aligne en ligne */
  }

}

</style>
